import axios, { AxiosResponse, AxiosError } from "axios"

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:5001"

const getSystemApiKey = () => {
  const hostname = window.location.hostname
  if (hostname === "app.intuidesk.com") {
    return "architeck-1957163548"
  } else if (hostname === "staging.app.intuidesk.com") {
    return "architeck-4184167461"
  }
  return "architeck-"
}

export interface ErrorLogEntry {
  start: number
  end: number
  duration: number
  request: {
    url?: string
    method?: string
    data?: unknown
  }
  response: {
    data?: unknown
    status?: number
    statusText?: string
  }
}

let logs: ErrorLogEntry[] = []

export const errorLog = {
  store: (data: AxiosResponse | AxiosError, start: number, end: number) => {
    const entry: ErrorLogEntry = {
      start,
      end,
      duration: end - start,
      request: {},
      response: {},
    }

    if (axios.isAxiosError(data)) {
      // Error response
      if (data.response) {
        entry.request.url = data.config?.url
        entry.request.method = data.config?.method
        entry.request.data = data.config?.data
        entry.response.data = data.response.data
        entry.response.status = data.response.status
        entry.response.statusText = data.response.statusText
      } else if (data.request) {
        const err = data.toJSON() as { config?: { url?: string; method?: string; data?: unknown } }
        entry.request.url = err.config?.url
        entry.request.method = err.config?.method
        entry.request.data = err.config?.data
        entry.response.data = "No Response Received From Server"
      } else {
        entry.request.url = "Internal JS Error, Did Not Make It To Request"
      }
    } else {
      // Success response
      const response = data as AxiosResponse
      entry.request.url = response.config?.url
      entry.request.method = response.config?.method
      entry.request.data = response.config?.data
      entry.response.data = response.data
      entry.response.status = response.status
      entry.response.statusText = response.statusText
    }

    logs.unshift(entry)
  },

  getLogs: (): ErrorLogEntry[] => {
    return logs
  },

  clearLogs: () => {
    logs = []
  },

  send: async (): Promise<string | null> => {
    try {
      const result = await axios({
        method: "POST",
        url: API_BASE_URL + "/v1/logs_network_users",
        headers: {
          authorization: `Bearer ${getSystemApiKey()}`,
        },
        withCredentials: true,
        data: { logs },
      })
      return result.data?.data?._id || null
    } catch {
      return null
    }
  },
}

export default errorLog
